<script>
    import {Transport} from 'tone';
    import Slider from '@smui/slider'

    export let min = 60;
    export let max = 240;
    export let value = 50;
    export let step = 1;
    export let label = "";
    export let units = "";

    const handleInput = (event) => {
        Transport.bpm.value = value; // Update Tone.js BPM
    }
</script>

<div class="toneslider">
    <Slider
            input$aria-label="{label}"
            min="{min}"
            max="{max}"
            bind:value
            step="{step}"
            on:click={handleInput}
            style="flex: 1;"
    ></Slider>
    <div class="value">{value} <span class="units">{units}</span></div>
</div>

<style lang="scss">
  @use "../theme/_smui-theme.scss";

  .mdc-slider {
    flex: 1;
    height: smui-theme.rem(36);
    --mdc-theme-secondary: black;
  }

  .toneslider {
    display: flex;


      .value {
        margin-left: 10px;
        font-weight: bold;
        float: right;

        .units {
          font-weight: normal;
        }
      }

  }
</style>